module.exports = __webpack_public_path__ + "static/media/FirstBank.99e16301.png";